export default __webpack_public_path__ + "static/media/Invitation invalid-1.cd59b1e8.png";